<p-dialog class="createNewAssetDialog" [(visible)]="isVisible" [style]="{width: '65vw'}" (onHide)="onHideEmitter()" (onShow)="onShow()">
  <ng-template pTemplate="header">
    <h3>{{ isEdit ? 'Edit' :'Add New'}} Localization String</h3>
  </ng-template>
  <ng-template pTemplate="content">
    <div *ngIf="isEdit && entity.verified" class="p-mx-5" style="margin-bottom:1.5rem;background:rgba(255,193,7,0.12);border:1px solid rgba(255,193,7,0.4);border-radius:4px;padding:10px 14px;display:flex;align-items:center;gap:10px;">
      <i class="fa-solid fa-triangle-exclamation" style="color:#ffc107;font-size:1rem;flex-shrink:0;"></i>
      <span style="color:#ffc107;font-size:0.85rem;line-height:1.4;">This record is <strong>Verified</strong>. Saving will update the text but auto-translation will be skipped. Use <strong>Force Translate</strong> to re-translate.</span>
    </div>
    <div class="p-grid p-mx-5">
      <div class="p-col-12 p-inputgroup" *ngIf="this.type == 'localization/client-strings' && !isEdit">
        <span ngClass="p-float-label">
          <input [(ngModel)]="entity._recordId" pInputText class="field-item" />
          <label for="entity.Key">Key <strong style="color: crimson">*</strong></label>
        </span>
      </div>
      <div class="p-col-12 p-inputgroup" *ngIf="this.type == 'localization/localized-strings' && !isEdit">
        <span ngClass="p-float-label">
          <input [(ngModel)]="entity.field" pInputText class="field-item" />
          <label for="entity.field">Field <strong style="color: crimson">*</strong></label>
        </span>
      </div>
      <div class="p-col-12 p-inputgroup">
        <span ngClass="p-float-label">
          <input [(ngModel)]="entity.Source_en" pInputText class="field-item" />
          <label for="entity.Source_en">English <strong style="color: crimson">*</strong></label>
        </span>
      </div>
      <div class="p-col-12 p-inputgroup">
        <span ngClass="p-float-label">
          <input [(ngModel)]="entity.Target_frFR" pInputText class="field-item" />
          <label for="entity.Target_frFR">French</label>
        </span>
      </div>
      <div class="p-col-12 p-inputgroup">
        <span ngClass="p-float-label">
          <input [(ngModel)]="entity.Target_esMX" pInputText class="field-item" />
          <label for="entity.Target_esMX">Spanish</label>
        </span>
      </div>
      <div class="p-col-12 p-inputgroup">
        <span ngClass="p-float-label">
          <input [(ngModel)]="entity.Target_deDE" pInputText class="field-item" />
          <label for="entity.Target_deDE">German</label>
        </span>
      </div>
      <div class="p-col-12 p-inputgroup">
        <span ngClass="p-float-label">
          <p-toggleButton
            onLabel="Verified" offLabel="Not Verified" onIcon="fa-solid fa-language" offIcon="fa-solid fa-xmark" [(ngModel)]="entity.verified"
          >
          </p-toggleButton>
        </span>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="p-grid p-justify-end">
      <button pButton type="button" label="Cancel" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
      <button pButton type="button" label="Submit" icon="pi pi-check" class="p-button-text" (click)="submitForm()"></button>
    </div>
  </ng-template>
</p-dialog>
